import { render, staticRenderFns } from "./AfterSales.vue?vue&type=template&id=09553dea&scoped=true"
import script from "./AfterSales.vue?vue&type=script&lang=ts"
export * from "./AfterSales.vue?vue&type=script&lang=ts"
import style0 from "./AfterSales.vue?vue&type=style&index=0&id=09553dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09553dea",
  null
  
)

export default component.exports